import { useTranslation } from 'react-i18next';

export default function ProgramsController() {
    const { t } = useTranslation();

    return (
        <div>
            <h1>{t('Welcome to our programs')}</h1>
            <p>{t('Choose a program that suits your interests and goals')}</p>
            <button>{t('View All Programs')}</button>
        </div>
    );
}